// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exportExcelBtn {
  height: 30px;
  background-color: #fff;
  margin-left: 15px;
}

.exportExcelBtn:hover {
  border: 1px solid #0094ff;
  background-color: #0094ff;
}

.prescreened {
  width: 9px;
  height: 9px;
  border-radius: 700px;
  background-color: green;
  display: inline-block;
}

.contacted {
  width: 9px;
  height: 9px;
  border-radius: 700px;
  background-color: orange;
  display: inline-block;
}

.disqualified {
  width: 9px;
  height: 9px;
  border-radius: 700px;
  background-color: red;
  display: inline-block;
}

.incomplete {
  width: 9px;
  height: 9px;
  border-radius: 700px;
  background-color: gray;
  display: inline-block;
}

.scheduled {
  width: 9px;
  height: 9px;
  border-radius: 700px;
  background-color: blue;
  display: inline-block;
}

.prequalified {
  width: 9px;
  height: 9px;
  border-radius: 700px;
  background-color: yellow;
  display: inline-block;
}

.phone {
  width: 120px;
}

.age {
  width: 100px;
}

.studyName {
  width: 170px;
}

.gender {
  width: 130px;
}

.applicant-search {
  width:auto; 
  flex-grow: 1; 
  padding-left: 40px;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}

:host ::ng-deep button {
  margin-right: .25em;
}

::ng-deep p-multiselect ul,
::ng-deep p-multiselect ol {
  padding-left: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/admin-participant-list/admin-participant-list.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;AAC5B","sourcesContent":[".exportExcelBtn {\r\n  height: 30px;\r\n  background-color: #fff;\r\n  margin-left: 15px;\r\n}\r\n\r\n.exportExcelBtn:hover {\r\n  border: 1px solid #0094ff;\r\n  background-color: #0094ff;\r\n}\r\n\r\n.prescreened {\r\n  width: 9px;\r\n  height: 9px;\r\n  border-radius: 700px;\r\n  background-color: green;\r\n  display: inline-block;\r\n}\r\n\r\n.contacted {\r\n  width: 9px;\r\n  height: 9px;\r\n  border-radius: 700px;\r\n  background-color: orange;\r\n  display: inline-block;\r\n}\r\n\r\n.disqualified {\r\n  width: 9px;\r\n  height: 9px;\r\n  border-radius: 700px;\r\n  background-color: red;\r\n  display: inline-block;\r\n}\r\n\r\n.incomplete {\r\n  width: 9px;\r\n  height: 9px;\r\n  border-radius: 700px;\r\n  background-color: gray;\r\n  display: inline-block;\r\n}\r\n\r\n.scheduled {\r\n  width: 9px;\r\n  height: 9px;\r\n  border-radius: 700px;\r\n  background-color: blue;\r\n  display: inline-block;\r\n}\r\n\r\n.prequalified {\r\n  width: 9px;\r\n  height: 9px;\r\n  border-radius: 700px;\r\n  background-color: yellow;\r\n  display: inline-block;\r\n}\r\n\r\n.phone {\r\n  width: 120px;\r\n}\r\n\r\n.age {\r\n  width: 100px;\r\n}\r\n\r\n.studyName {\r\n  width: 170px;\r\n}\r\n\r\n.gender {\r\n  width: 130px;\r\n}\r\n\r\n.applicant-search {\r\n  width:auto; \r\n  flex-grow: 1; \r\n  padding-left: 40px;\r\n}\r\n\r\n.disabled {\r\n  pointer-events: none;\r\n  opacity: 0.5;\r\n}\r\n\r\n:host ::ng-deep button {\r\n  margin-right: .25em;\r\n}\r\n\r\n::ng-deep p-multiselect ul,\r\n::ng-deep p-multiselect ol {\r\n  padding-left: 0 !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
